var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatternHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 279.732,
    height: 240.039,
    viewBox: "0 0 279.732 240.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2591"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4301",
    transform: "translate(159.846 .003)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h.018v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4302",
    transform: "translate(239.77 .003)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v80.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4303",
    transform: "translate(199.808 40.026)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h79.924v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12366",
    d: "M742.682 66.2h79.924v39.987h-39.962v-.024l-39.962-39.941z",
    transform: "translate(-582.835 13.851)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12367",
    d: "M815.712 99.342v119.985h-39.961V99.342h.009v-.055h19.963l-.009.055z",
    transform: "translate(-575.942 -59.262)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4304",
    transform: "translate(239.77 160.107)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4305",
    transform: "translate(119.884 160.107)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4306",
    transform: "translate(39.962 120.069)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4307",
    transform: "translate(0 40.035)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12368",
    d: "M782.641 39.989H742.7L782.623 0h.018z",
    transform: "translate(-582.832)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4308",
    transform: "translate(119.886)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v39.987H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4309",
    transform: "translate(119.884 40.026)",
    style: {
      fill: "#cdea50"
    },
    d: "M0 0h39.962v.018H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12369",
    d: "M749.575 73.066v.018h-39.962V33.116z",
    transform: "translate(-589.729 6.928)",
    style: {
      fill: "#cdea50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12372",
    d: "M822.605 172.351v39.987h-79.923v-39.945l39.962-39.987v39.945z",
    transform: "translate(-582.835 27.701)",
    style: {
      fill: "#cdea50"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternHeader);
export default __webpack_public_path__ + "static/media/pattern-header.4ce7e64f24da08fb92db8650822d9bc2.svg";
export { ForwardRef as ReactComponent };